import { createMask } from "imask";

export const createAddressNumberMask = () => createMask({ mask: Number, scale: 0, signed: false });

export const createPostalCodeMask = () => createMask({ mask: "00000-000" });
